import { useEffect , useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NaverCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const alreadyCalled = useRef(false); // ✅ 중복 호출 방지

  useEffect(() => {

    if (alreadyCalled.current) return;
    alreadyCalled.current = true;

    const query = new URLSearchParams(location.search);
    const code = query.get("code");
    const state = query.get("state");

    if (code) {

      fetch(`${baseUrl}/api/naver/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code, state }),
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("서버 응답 오류");
          }
          return res.json();
        })
        .then((data) => {
          if (data.token) {
            sessionStorage.setItem("jwt", data.token);
            sessionStorage.setItem("userName", data.name);
            sessionStorage.setItem("userEmail", data.email);
            sessionStorage.setItem("isLoggedIn", "true");
            sessionStorage.setItem("isAdmin", data.isAdmin ? "true" : "false");

            // ✅ URL 정리 및 홈으로 이동
            navigate("/", { replace: true });
          } else {
            console.error("❌ 서버 응답에 토큰 없음:", data);
            alert("로그인 실패: 서버 응답 오류");
            navigate("/", { replace: true });
          }
        })
        .catch((err) => {
          console.error("❌ 서버 로그인 요청 실패:", err);
          alert("로그인 중 오류가 발생했습니다.");
          navigate("/", { replace: true });
        });
    } else {
      console.error("❌ code 없음: 로그인 실패 또는 취소됨");
      alert("네이버 로그인 실패: code 없음");
      navigate("/", { replace: true });
    }
  }, [location.search, navigate]);

  return <div>로그인 처리 중입니다...</div>;
};

export default NaverCallback;
